import { useSearch } from "@tanstack/react-router";

import { NamedResourceCRUDPage } from "../components/named_resource_crud";
import { accountsAdapter } from "../components/accounts/accountsAdapter";
import { TransactionsSection } from "../components/transactions/TransactionsSection";

type AccountsSearch = { newTransaction?: boolean };

export function AccountsPage() {
  const search = useSearch({ strict: false }) as AccountsSearch;
  return (
    <div className="space-y-6 pb-6">
      <NamedResourceCRUDPage adapter={accountsAdapter} />
      <div className="px-6">
        <TransactionsSection autoOpenCreate={search.newTransaction === true} />
      </div>
    </div>
  );
}
